import React, { useEffect } from "react";
import "./styles.css";
import "../styles.css";
import { CsBrokenIcon, CsDashboardIcon, CsEditIcon, CsNotifIcon, EmergencyIcon, GradientQrIcon, NoParkingIcon, SecuredCallIcon, TowingIcon } from "../../../Assets/images/svgs";
import { Carousel, CSHeader } from "../../../Components/Atoms";
import { CsStepOneNew, CsStepTwoNew, CsStepThreeNew, CsStepFourNew } from "../../../Assets/images/pngs";
import { useNavigate } from "react-router-dom";
import { logFirebaseEvent } from "../../../firebase/logEventHelper";
import { CS_BUY_NOW_LINK } from "../../../Library/constants";

const LandingPage = () => {
  const slides = [
    { idx: 1, img: CsStepOneNew, },
    { idx: 2, img: CsStepTwoNew, },
    { idx: 3, img: CsStepThreeNew, },
    { idx: 4, img: CsStepFourNew, },
  ];

  const advantages = [
    { idx: 1, icon: <SecuredCallIcon />, heading: "Secured Calls", description: "Internet-masked calls-keeps your phone number private." },
    { idx: 2, icon: <CsNotifIcon />, heading: "Notification History", description: "Keep track of all the current and previous notifications" },
    { idx: 3, icon: <CsDashboardIcon />, heading: "Be Informed", description: "Know instantly when someone scans your QR code & take prompt actions when they call you." },
    { idx: 4, icon: <CsEditIcon />, heading: "Control What Others See", description: "Customize the details shown when someone scans the QR." },
    { idx: 5, icon: <CsBrokenIcon />, heading: "Prevent Frustration & Damage", description: "Avoid conflicts and vehicle damage from improper parking." },
  ]

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");
  }, []);

  const goBack = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  const navigateInApp = () => {
    logFirebaseEvent("ACTIVATE_CONTACT_STICKER");
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "activate-sticker" }));
  }

  const buyContactSticker = () => {
    window.open(CS_BUY_NOW_LINK, '_blank')
  }

  return (
    <div className="cs-landing-page">
      <CSHeader onClick={goBack} headerText=" " />

      <div className="cs-carousel-content-box">
        <div className="cs-title-container">
          <div className="cs-highlighted-title">
            <GradientQrIcon />
            <p className="cs-text-gradient">
              Smart Contact Sticker
            </p>
          </div>
        </div>
        <p className="cs-subheading">A step forward to make your vehicle SAFE and SMART</p>
        <div className="carousel-container">
          <Carousel slides={slides} />
        </div>
      </div>

      <div className="cs-activate-or-buy-btns">
        <button className="cs-activate-btn cs-btn-gradient" onClick={navigateInApp}>
          Activate contact sticker
        </button>
        <button className="cs-buy-btn cs-btn-gradient" onClick={buyContactSticker}>
          <div className="cs-btn-box">
            <span className="cs-text-gradient">Buy a new contact sticker</span>
          </div>
        </button>
      </div>

      <div className="cs-other-helps">
        <p className="cs-others-heading">Beyond parking problems</p>
        <div className="cs-others-block-container">
          <div className="cs-others-block">
            <NoParkingIcon />
            <p>No Parkings</p>
          </div>
          <div className="cs-others-block center-block">
            <EmergencyIcon />
            <p>Emergencies</p>
          </div>
          <div className="cs-others-block">
            <TowingIcon />
            <p>Vehicle towing</p>
          </div>
        </div>
      </div>

      <div className="cs-advantages-box">
        <p className="cs-advantages-heading">Get informed & stay connected with your vehicle</p>
        <div className="advantages-box">
            {advantages.map(advntg => (
              <React.Fragment key={advntg.idx}>
                <div className="cs-advantage">
                  <div className="cs-advantage-image">{advntg.icon}</div>
                  <div className="cs-advantage-point">
                    <p className="cs-advantage-point cs-text-gradient">{advntg.heading}</p>
                    <p className="cs-advantage-desc">{advntg.description}</p>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>

      <div className="cs-activate-or-buy-btns">
        <button className="cs-activate-btn cs-btn-gradient" onClick={navigateInApp}>
          Activate contact sticker
        </button>
        <button className="cs-buy-btn cs-btn-gradient" onClick={buyContactSticker}>
          <div className="cs-btn-box">
            <span className="cs-text-gradient">Buy a new contact sticker</span>
          </div>
        </button>
      </div>
    </div>
)
}

export default LandingPage
